const JOURS = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];
const JOURS_COURTS = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];
const MOIS = [
  'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
  'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
];

// Get Monday of the week containing date
function getMonday(d) {
  const date = new Date(d);
  const day = date.getDay();
  const diff = date.getDate() - day + (day === 0 ? -6 : 1);
  date.setDate(diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

function getSunday(mondayDate) {
  const d = new Date(mondayDate);
  d.setDate(d.getDate() + 6);
  return d;
}

function formatDate(d) {
  const date = new Date(d);
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = date.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
}

function formatDateISO(d) {
  const date = new Date(d);
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = date.getFullYear();
  return `${yyyy}-${mm}-${dd}`;
}

function addDays(date, days) {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
}

function addWeeks(date, weeks) {
  return addDays(date, weeks * 7);
}

function getWeekDays(monday) {
  const days = [];
  for (let i = 0; i < 7; i++) {
    days.push(addDays(monday, i));
  }
  return days;
}

function getWeekOffset(currentMonday) {
  const today = getMonday(new Date());
  const diff = Math.round((currentMonday - today) / (1000 * 60 * 60 * 24 * 7));
  return diff;
}

function getWeekLabel(offset) {
  if (offset === 0) return 'Semaine en cours';
  if (offset > 0) return `Semaine+${offset}`;
  return `Semaine${offset}`;
}

function getMonthsInWeek(monday) {
  const sunday = getSunday(monday);
  const months = new Set();
  months.add(monday.getMonth());
  months.add(sunday.getMonth());
  return [...months].map(m => ({
    month: m + 1,
    year: monday.getMonth() === m ? monday.getFullYear() : sunday.getFullYear(),
    name: MOIS[m]
  }));
}

// Generate half-hour time slots
function generateTimeSlots(openTime = '09:00', closeTime = '19:00') {
  const slots = [];
  const [openH, openM] = openTime.split(':').map(Number);
  const [closeH, closeM] = closeTime.split(':').map(Number);
  
  let h = openH, m = openM;
  while (h < closeH || (h === closeH && m < closeM)) {
    const start = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
    m += 30;
    if (m >= 60) { h++; m = 0; }
    const end = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
    slots.push({ start, end });
  }
  return slots;
}

function getISOWeekNumber(date) {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
}

export {
  JOURS, JOURS_COURTS, MOIS,
  getMonday, getSunday, formatDate, formatDateISO,
  addDays, addWeeks, getWeekDays, getWeekOffset, getWeekLabel,
  getMonthsInWeek, generateTimeSlots, getISOWeekNumber
};
